import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { typeOf } from '@ember/utils';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<li\n  class=\'draggable-dropzone file-upload-wrap {{this.dragClass}}\'\n  ...attributes\n  data-test-on-drop\n  {{on \'drop\' this.onDrop}}\n  {{on \'dragover\' this.onDragOver}}\n  {{on \'dragleave\' this.onDragLeave}}\n>\n  {{yield}}\n</li>");

var _class, _descriptor;
let BbDropzoneComponent = (_class = class BbDropzoneComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "dragClass", _descriptor, this);
  }
  onDrop(event) {
    event.preventDefault();
    this.dragClass = 'deactivated';
    const data = event.dataTransfer.getData('text/data');
    if (typeOf(this.args.dropped) === 'function') {
      this.args.dropped(data, this.args.destination);
    }
    return true;
  }
  onDragOver(event) {
    event.preventDefault();
    this.dragClass = 'activated';
  }
  onDragLeave(event) {
    event.preventDefault();
    this.dragClass = 'deactivated';
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "dragClass", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "onDrop", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDrop"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDragOver", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDragOver"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDragLeave", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDragLeave"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbDropzoneComponent);

export { BbDropzoneComponent as default };
//# sourceMappingURL=bb-dropzone.js.map
